import React from "react";
import PropTypes from "prop-types";
import { getAngle } from "../utils";
import MainBubble from "./main-bubble";
import AuxiliaryBubbleList from "./auxiliary-bubble-list";
import BubbleConnector from "./bubble-connector";
import WaveAnimation from "../wave-animation";
import style from "./style";

const BubbleComponent = ({
  mainBubble,
  auxBubbles,
  setBubble,
  isActive,
  currentBubble,
  radius = 40,
  taggingInfo,
}) => {
  
  return (
    <>
      <article className="bubble-component" data-cy="Ecosystem Bubble Component">
        <WaveAnimation expand={2} />
        <BubbleConnector
          isActive={isActive}
          angle={getAngle(currentBubble - 1, auxBubbles?.length)}
          radius={radius}
        />
        <MainBubble {...mainBubble} isActive={isActive} />
        <AuxiliaryBubbleList
          auxBubbles={auxBubbles}
          onClick={setBubble}
          radius={radius}
          currentBubble={currentBubble}
          isActive={isActive}
          taggingInfo={taggingInfo}
        />
      </article>
      <style jsx>{style}</style>
    </>
  );
};

export default BubbleComponent;
